import { j as r } from "../../../jsx-runtime-82a9ddf6.js";
const x = ({ width: c = 20, height: l = 20, className: o, style: e }) => /* @__PURE__ */ r.jsxs("svg", { width: c, height: l, className: o, style: e, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ r.jsx("circle", { cx: "5.25", cy: "10.25", r: "1.25", fill: "currentColor" }),
  /* @__PURE__ */ r.jsx("circle", { cx: "10.25", cy: "10.25", r: "1.25", fill: "currentColor" }),
  /* @__PURE__ */ r.jsx("circle", { cx: "15.25", cy: "10.25", r: "1.25", fill: "currentColor" })
] });
export {
  x as MoreIcon
};
